import { useState, } from "react"


const useProgressiveImage = (src) => {  
    const [sourceLoaded, setSourceLoaded] = useState(null)

      const img = document.createElement('img')
      img.src = src
      img.onload = () => setSourceLoaded(src)

    return sourceLoaded 
  }



export default useProgressiveImage;